import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'

import 'styles/AntOverrides.css'
import 'styles/ChecComponents.css'
import 'styles/Button.css'

const ChecButton = ({
  className,
  disabled,
  text,
  onClick,
  type,
  children,
  size,
  loading,
  style,
}) => (
  <Button
    className={`chec-button ${className || ''}`}
    disabled={disabled}
    onClick={onClick}
    type={type}
    style={style}
    size={size}
    loading={loading}
  >
    {text || children}
  </Button>
)

ChecButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'default', 'large']),
  type: PropTypes.oneOf(['primary', 'default', 'secondary', 'danger']),
  style: PropTypes.object,
}

export default ChecButton
